import { render } from "./Purchase_Modal.vue?vue&type=template&id=6c257dea"
import script from "./Purchase_Modal.vue?vue&type=script&lang=js"
export * from "./Purchase_Modal.vue?vue&type=script&lang=js"

import "./Purchase_Modal.vue?vue&type=style&index=0&id=6c257dea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__